import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "../../../design/dialog";
import { useInvitation } from "../../../contexts/InvitationContext";
import { Invitation } from "../../../models/Invitation";
import { Button } from "../../../design/button";

interface InvitationDialogProps {
  invitation: Invitation;
}

const InvitationDialog: React.FC<InvitationDialogProps> = ({ invitation }) => {
  const { updateInvitation } = useInvitation();
  const [isOpen, setIsOpen] = useState(false);

  const handleInvitationStatus = async (status: Invitation["status"]) => {
    try {
      switch (status) {
        case "accepted":
          await updateInvitation(invitation._id, { status: "accepted" });
          break;
        case "declined":
          await updateInvitation(invitation._id, { status: "declined" });
          break;
        case "pending":
          break;
        default:
          console.error("Invalid status");
          break;
      }
    } catch (error) {
      console.error("Error updating invitation status:", error);
    }
  };
  return (
    <>
      <Button onClick={() => setIsOpen(true)}>View</Button>
      <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
        <DialogTitle>Invitations</DialogTitle>
        <DialogBody>{invitation.message}</DialogBody>
        <DialogActions>
          <Button
            color="red"
            onClick={() => {
              setIsOpen(false);
              handleInvitationStatus("declined");
            }}
          >
            Decline
          </Button>
          {invitation.status === "pending" && (
            <Button
              color="green"
              onClick={() => {
                setIsOpen(false);
                handleInvitationStatus("accepted");
              }}
            >
              Accept
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default InvitationDialog;
